document.addEventListener('DOMContentLoaded', function () {
    initializeAddToCartButtons();
    document.showBySku();
});

function initializeAddToCartButtons() {
    const addToCartButton = document.querySelectorAll('.fbt-add-button');
    const fbtSelect = document.querySelectorAll('.fbt-select');
    addToCartButton.forEach((button) => {
        button.addEventListener('click', handleAddToCartClick);
    });
    fbtSelect.forEach((select) => {
        select.addEventListener('change', handleSelectChangePrice);
    });
}

function handleSelectChangePrice() {
    const selectedOption = this.options[this.selectedIndex]; // Obtiene la opción seleccionada
    const price = selectedOption.getAttribute('data-price'); // Obtiene el atributo data-price

    const priceElement = this.closest('.fbt-product').querySelector('.fbt-product-price'); // Encuentra el elemento con la clase fbt-product-price dentro del contenedor más cercano
    if (priceElement) {
        priceElement.innerHTML = price; // Asigna el precio al innerHTML
    }
}

function handleAddToCartClick() {
    const id = this.getAttribute('data-product-id');
    const variantSelect = document.getElementById(`fbt-size-${id}`);
    const variantId = variantSelect.value;
    const quantity = 1;

    addToCart(variantId, quantity);
}

function addToCart(variantId, quantity) {
    const isMobile = isMobileDevice();

    let cart = isMobile ? document.querySelector('cart-drawer') : document.querySelector('cart-notification');
    if (isMobile) {
        cart.classList.remove('is-empty');
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity }],
            sections: cart.getSectionsToRender().map((section) => section.id),
        }),
    })
    .then((response) => response.json())
    .then((data) => handleAddToCartResponseFrequently(data, cart))
    .catch((error) => console.error('Error:', error));

    toggleSpinner(true);
}

function isMobileDevice() {
    return (window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent));
}

function handleAddToCartResponseFrequently(data, cart) {
    console.log('Producto añadido:', data);

    window.upsellLogic();
    let item = data.items[0];
    item['sections'] = data.sections;
    cart.setActiveElement(document.activeElement);
    cart.renderContents(item);

    toggleSpinner(false);
}

function toggleSpinner(show) {
    const button = document.querySelector('.product-form__buttons button');
    const spinner = document.querySelector('.loading-overlay__spinner');

    if (spinner) {
        if (show) {
            button.style.opacity = '0.5';
            spinner.classList.remove('hidden');
        } else {
            spinner.classList.add('hidden');
            button.style.opacity = '';
        }
    }
}

document.showBySku = function () {
    let fbtProducts = document.querySelectorAll('.fbt-product');
    let fbtContainer = document.querySelector('.frequently-bought-together');

    fbtProducts.forEach((product) => {
        if (product.getAttribute('data-is-show-sku') == 'true') {
            handleProductSkuVisibility(product);
        }
    });

    updateFbtContainerVisibility(fbtContainer);
};

function handleProductSkuVisibility(product) {
    let skus = JSON.parse(product.getAttribute('data-skus'));
    let dataProduct = document.dataProduct;
    let variantIdSelected = document.querySelector("input[name='id']").value;

    let variantSkuFind = dataProduct.find(variant => variant.id == variantIdSelected);
    let sku = skus.find(sku => variantSkuFind.sku.includes(sku));

    if (sku) {
        product.classList.remove('hidden');
    } else {
        product.classList.add('hidden');
    }
}

function updateFbtContainerVisibility(fbtContainer) {
    const fbtProductsHidden = document.querySelector('.fbt-product:not(.hidden)');
    if (fbtProductsHidden) {
        fbtContainer.classList.remove('hidden');
    } else {
        fbtContainer.classList.add('hidden');
    }
}
